export const sectionA = "Section A: Basic Information";
export const sectionB = "Section B: My Company";
export const userBinding = "User Binding";
export const taxpayerInfo = "Taxpayer's Info Maintenance";
export const contractDetails = "Contract Details";

export const taxpayerSectionA = "Section A: Taxpayer 's Information";
export const taxpayerSectionB = "Section B: Contract Information";
export const taxpayerSectionC = "Section C: User Information";
export const businesSystemPermissions="Business System Permissions";
export const selectBusinessSystem="Select Business System";


export const account = {label:"Account",name:"account"};
export const userName = {label:"User Name",name:"userName"};
export const contactNumber = {label:"Contact Number",name:"contactNumber"};
export const numberOfContracts = {label:"Number of Contracts",name:"numberOfContracts"};
export const contactName = {label:"Contact Name",name:"contactName"};
export const email = {label:"Email",name:"email"};
export const userType = {label:"User Type",name:"userType"};
export const roleName = {label:"Role Name",name:"rolename"};
export const businessSystems = {label:"Business System Permissions",name:"businessSystems"};
export const roleManagement = {label:"Role Management",name:"roleManagement"};
export const plsSelectPerm = "please select the permission";
export const plsSetOtherRoles = "Please set up other roles besides the administrator.";


export const contractNumber = {label:"Contract Number",name:"contractNumber"};
export const contractStartDate = {label:"Contract Start Date",name:"contractStartDate"};
export const contractEndDate = {label:"Contract End Date",name:"contractEndDate"};
export const userLimit = {label:"User Limit",name:"userLimit"};
export const remainingUserLimit = {label:"Remaining User Limit",name:"remainingUserLimit"};
export const transactionLimit = {label:"Transaction Limit",name:"transactionLimit"};
export const remainingTransactionLimit = {label:"Remaining Transaction Limit",name:"remainingTransactionLimit"};
export const invoiceLimit = {label:"Invoice Limit",name:"invoiceLimit"};
export const remainingInvoiceLimit = {label:"Remaining Invoice Limit",name:"remainingInvoiceLimit"};
export const contractStatus = {label:"Contract Status",name:"contractStatus"};
export const cancelReason = {label:"Reason for cancellation",name:"cancelReason"};

export const allBusinessStatus={label:"Obtain all business system?",name:"allBusinessStatus"};

export const largeFileDownload = {label:"Enable large file download",name:"largeFileDownload"};
export const businessSystemImportTemplateTip="The business systems can only be imported by batch using this template.";
export const taxpayerInfoBtnTip="Only administrator users can perform information maintenance.";
export const bindingBtnTip="Only the administrator can perform user binding.";
